function tabs(tabsGroup){
    const getButTabs = document.querySelectorAll(`${tabsGroup}[data-tab-but]`);
    getButTabs.forEach(function(element, index){
        element.addEventListener('click', showTab, false);
    });
    const getAllTabs = document.querySelectorAll(`${tabsGroup}[data-tab]`);
    function showTab(){
        let curTarget = this.dataset.tabBut;
        getButTabs.forEach(element => {
            element.classList.remove('active');
        });
        this.classList.add('active');
        getAllTabs.forEach(element => {
            element.classList.remove('active');
        });
        let getTab = document.querySelectorAll(`${tabsGroup}[data-tab="${curTarget}"]`);
        getTab.forEach(function(tabelem){
            tabelem.classList.add('active');
        });
    }
}

module.exports = tabs;